// lib/chat/chatSessionDeletion.ts
import type { RefObject } from 'react';
import type { ConfirmationModalPayload, KernelHandle, UndoableAction } from '#types/types';

/** Asks first; the deletion itself stays free of UI, since agents call it too. */
export const confirmChatSessionDeletion = (kernel: RefObject<KernelHandle | null>, sessionId: string) => {
  const k = kernel.current;
  if (!k) return;
  const name = k.getInventory().ChatSession.registry[sessionId]?.name?.trim() || 'New chat';
  k.openModal('Confirmation', {
    title: 'Delete chat?',
    message: `This will permanently delete "${name}" and its messages. It can't be undone.`,
    confirmLabel: 'Delete',
    onConfirm: () => kernel.current?.deleteChatSession(sessionId),
  } satisfies ConfirmationModalPayload);
};

// A deleted session's messages are gone server-side: its undo entries would restore nothing.
export const withoutChatSessionActions = (stack: UndoableAction[], sessionId: string): UndoableAction[] =>
  stack.filter((action) => action.chatSessionId !== sessionId);
